<div
  class="series-overlay-container d-block animate__animated animate__fadeIn animate__delay-0.5s"
  [style.left.px]="position.left"
  [style.top.px]="position.top"
  [style.width.px]="position.width"
  *ngIf="playerStatus"
>
  <div class="series-overlay">
    <div [routerLink]="data | redirectUrl">
      <div class="overlay-img ratio-16-9" *ngIf="data?.trailer">
        <video
          id="my-model-video"
          #model
          class="video-js vjs-big-play-centered"
          autoplay="true"
          loop="true"
          playsinline
          preload="none"
        >
          <source [src]="data?.trailer" type="video/mp4" />
        </video>
      </div>
      <div class="overlay-img ratio-16-9" *ngIf="!data?.trailer">
        <img
          src="{{ data?.thumbnails | thumbnails: 'landscape' }}"
          [src-fallback]="appConstant?.landscapeDefault"
        />
      </div>
    </div>

    <div class="overlay-info">
      <h4 class="mt-0 mb-2 info_title">{{ data?.name }}</h4>
      <!-- <h6
        class="mb-2 text-secondary"
        *ngIf="
          data?.type == 'series' &&
          data?.total_season > 0 &&
          data?.total_episode > 0
        "
      >
        S{{ data?.total_season }} E{{ data?.total_episode }}
      </h6> -->

      <h5 class="font-14 text-secondary mb-1" *ngIf="data?.type == 'video'">
        {{ data.duration ? (data?.duration | second_time) : "" }}
        {{ data?.published_year && data.duration ? "," : "" }}
        {{ data?.published_year ? data?.published_year : "" }}
      </h5>

      <div class="font-14" *ngIf="data?.genres.length > 0">
        <p class="text-secondary mb-2" *ngIf="data.type == 'series'">
          <span *ngFor="let item of data?.genres; let isLast = last">
            {{ item?.name }} {{ isLast ? "" : ", " }}</span
          >
        </p>
        <p
          class="text-secondary mb-2"
          *ngIf="data.type == 'video' || data.type == 'live'"
        >
          <span *ngFor="let item of data?.genres; let isLast = last">
            {{ item?.name }} {{ isLast ? "" : ", " }}</span
          >
        </p>
      </div>
      <p class="info_desc text-truncate">
        {{
          data?.description?.length > 100
            ? (data?.description | slice: 0:100) + ".."
            : data?.description
        }}
      </p>
      <div class="growOverlay_btnBlock">
        <div class="divider-block">
          <div class="d-flex align-items-start icons-box">
            <div
              matTooltip="{{ 'VIDEO_DETAIL.LIKE_TIP' | translate }}"
              class="social-icons"
              *ngIf="isLogin"
            >
              <button
                [disabled]="data?.likeDislikeDisable == 1"
                (click)="likeDislike(1)"
                mat-button
                class="circle-btn"
                [ngClass]="{ favorite: data?.is_user_likeDislike == 1 }"
              >
                <span
                  class="social-icon"
                  [ngClass]="{
                    'icon-like-border':
                      !likeLoader &&
                      (data?.is_user_likeDislike == 0 ||
                        data?.is_user_likeDislike == null),
                    'icon-like': data?.is_user_likeDislike == 1 && !likeLoader,
                    'spin icon-loader': likeLoader
                  }"
                ></span>
                <!-- <span class="social-h">{{ data?.total_like }} </span> -->
              </button>
            </div>
            <div
              matTooltip="{{ 'VIDEO_DETAIL.LIKE_TIP' | translate }}"
              class="social-icons"
              *ngIf="!isLogin"
            >
              <button
                [matMenuTriggerFor]="like"
                [disabled]="data?.likeDislikeDisable == 1"
                (click)="likeDislike(1)"
                mat-button
                class="circle-btn"
                [ngClass]="{ favorite: data?.is_user_likeDislike == 1 }"
              >
                <span
                  class="social-icon"
                  [ngClass]="{
                    'icon-like-border':
                      data?.is_user_likeDislike == 0 ||
                      data?.is_user_likeDislike == null,
                    'icon-like': data?.is_user_likeDislike == 1
                  }"
                ></span>
                <!-- <span class="social-h">{{ data?.total_like }} </span> -->
              </button>

              <mat-menu #like="matMenu" class="please_login">
                <div (click)="$event.stopPropagation()">
                  <h4>{{ "VIDEO_DETAIL.LIKE_THIS_VIDEO" | translate }}</h4>
                  <p>{{ "VIDEO_DETAIL.SIGNIN_MESSAGE" | translate }}</p>
                  <hr />
                  <a href="javascript:void(0)" (click)="singIn('like')">
                    {{ "VIDEO_DETAIL.SIGN_IN" | translate }}</a
                  >
                </div>
              </mat-menu>
            </div>
            <div
              matTooltip="{{ 'VIDEO_DETAIL.DISLIKE_TIP' | translate }}"
              class="social-icons"
              *ngIf="isLogin"
            >
              <button
                [disabled]="data?.likeDislikeDisable == 0"
                (click)="likeDislike(0)"
                mat-button
                class="circle-btn"
                [ngClass]="{ favorite: data?.is_user_likeDislike == 0 }"
              >
                <span
                  class="social-icon"
                  [ngClass]="{
                    'icon-dis-like-border':
                      !dislikeLoader &&
                      (data?.is_user_likeDislike == 1 ||
                        data?.is_user_likeDislike == null),
                    'icon-dis-like':
                      data?.is_user_likeDislike == 0 && !dislikeLoader,
                    'spin icon-loader': dislikeLoader
                  }"
                ></span>
              </button>
            </div>
            <div
              matTooltip="{{ 'VIDEO_DETAIL.DISLIKE_TIP' | translate }}"
              class="social-icons"
              *ngIf="!isLogin"
            >
              <button
                [matMenuTriggerFor]="dislike"
                [disabled]="data?.likeDislikeDisable == 0"
                (click)="likeDislike(0)"
                mat-button
                class="circle-btn"
                [ngClass]="{ favorite: data?.is_user_likeDislike == 0 }"
              >
                <span
                  class="social-icon"
                  [ngClass]="{
                    'icon-dis-like-border':
                      data?.is_user_likeDislike == 1 ||
                      data?.is_user_likeDislike == null,
                    'icon-dis-like': data?.is_user_likeDislike == 0
                  }"
                ></span>
              </button>
              <mat-menu #dislike="matMenu" class="please_login">
                <div (click)="$event.stopPropagation()">
                  <h4>{{ "VIDEO_DETAIL.DONT_LIKE_THIS_VIDEO" | translate }}</h4>
                  <p>{{ "VIDEO_DETAIL.SIGNIN_MESSAGE" | translate }}</p>
                  <hr />
                  <a href="javascript:void(0)" (click)="singIn('dislike')">
                    {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
                  </a>
                </div>
              </mat-menu>
            </div>
            <div class="social-icons watchlist-icon">
              <!-- <button
                matTooltip="Add To Watchlist"
                mat-button
                class="circle-btn"
              >
                <span class="social-icon icon-watch-list"></span>
              </button> -->
              <button
                [matTooltip]="
                  data?.is_favorite?.id
                    ? ('VIDEO_DETAIL.ADDED_TO_LIST' | translate)
                    : ('VIDEO_DETAIL.ADD_TO_LIST' | translate)
                "
                mat-button
                (click)="favoriteVideo()"
                class="circle-btn"
                [ngClass]="{ favorite: data?.is_favorite?.id }"
                *ngIf="isLogin"
              >
                <span
                  class="social-icon"
                  [ngClass]="{
                    'mdi mdi-text-box-check-outline':
                      data?.is_favorite?.id && !watchlistLoader,
                    'icon-watch-list':
                      !data?.is_favorite?.id && !watchlistLoader,
                    'spin icon-loader': watchlistLoader
                  }"
                ></span>
                <!-- Add to {{ "VIDEO_DETAIL.FAVORITE" | translate }} -->
              </button>
              <button
                [matMenuTriggerFor]="watch"
                [matTooltip]="
                  data?.is_favorite?.id
                    ? ('VIDEO_DETAIL.ADDED_TO_LIST' | translate)
                    : ('VIDEO_DETAIL.ADD_TO_LIST' | translate)
                "
                mat-button
                class="circle-btn"
                [ngClass]="{ favorite: data?.is_favorite?.id }"
                *ngIf="!isLogin"
                (click)="favoriteVideo()"
              >
                <span
                  class="social-icon mr-1"
                  [ngClass]="{
                    'mdi mdi-text-box-check-outline':
                      data?.is_favorite?.id && !watchlistLoader,
                    'icon-watch-list':
                      !data?.is_favorite?.id && !watchlistLoader,
                    'spin icon-loader': watchlistLoader
                  }"
                ></span>
                <!-- Add to {{ "VIDEO_DETAIL.FAVORITE" | translate }} -->
              </button>
              <div>
                <mat-menu #watch="matMenu" class="please_login">
                  <div (click)="$event.stopPropagation()">
                    <h4>{{ "VIDEO_DETAIL.WATCH_AGAIN" | translate }}</h4>
                    <p>{{ "VIDEO_DETAIL.ADD_PLAYLIST" | translate }}</p>
                    <hr />
                    <a
                      href="javascript:void(0)"
                      (click)="singIn('is_favorite')"
                    >
                      {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
                    </a>
                  </div>
                </mat-menu>
              </div>
            </div>
          </div>
          <a
            class="btn btn-theme"
            href="javascript:void(0)"
            [routerLink]="data | redirectUrl"
            [queryParams]="{ watching: 'autoplay' }"
          >
            <span class="icon-play mr-2"></span>
            {{ "HOME.PLAY" | translate }}</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
